const MaterialIcon = ({ type }) => {
  return <span className="material-icons-outlined">{type}</span>;
};

export { MaterialIcon };
